import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import ErrorMessage from '../../components/errormessage';
import ThemedSpinner from '../../components/themed/ThemedSpinner';
import { useStores } from '../../hooks/use-stores';
import { useParams } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import AddRemoveList from '../../components/super/add-remove-list';

function AssessmentTemplateQuestions({ templateId: propTemplateId }) {
    const { superStore } = useStores();
    let { templateId: paramTemplateId } = useParams();
    const templateId = propTemplateId || paramTemplateId;
    const isNew = templateId === 'create' || !templateId;
    const {
        loadingAssessmentTemplate,
        editingAssessmentTemplate,
        assessmentTemplatesError,
        loadingQuestions,
        questions,
        loadingAssessmentTemplateQuestions,
        editingAssessmentTemplateQuestions,
        addAssessmentTemplateQuestion,
        deleteAssessmentTemplateQuestion,
    } = superStore;

    if (isNew || !templateId) {
        return (
            <Grid container direction="row" justify="center" align="center" spacing={2}>
                <Grid item xs={12}>
                    <Typography>Please save the assessment template first before adding questions.</Typography>
                </Grid>
            </Grid>
        );
    }

    return (
        <Grid
            container
            direction="row"
            justify="center"
            align="center"
            spacing={2}
        >
            {loadingQuestions || loadingAssessmentTemplateQuestions ? (
                <ThemedSpinner />
            ) : (
                <Fragment>
                    {assessmentTemplatesError && (
                        <Grid item>
                            <ErrorMessage error={assessmentTemplatesError} />
                        </Grid>
                    )}
                    {questions && (
                        <Fragment>
                            <Grid item xs={12}>
                                <Typography variant="h4" gutterBottom>
                                    Questions
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <AddRemoveList
                                    addItem={async (questionId) => {
                                        await addAssessmentTemplateQuestion(
                                            templateId,
                                            questionId
                                        );
                                        await superStore.loadAssessmentTemplateQuestions(
                                            templateId
                                        );
                                    }}
                                    removeItem={async (questionId) => {
                                        await deleteAssessmentTemplateQuestion(
                                            templateId,
                                            questionId
                                        );
                                        await superStore.loadAssessmentTemplateQuestions(
                                            templateId
                                        );
                                    }}
                                    itemList={questions.map((item) => {
                                        const name = item.name || `[${item.external_id || item.id}] Question ${item.id}`;
                                        return { ...item, name, question_id: item.id };
                                    })}
                                    activeItemList={
                                        editingAssessmentTemplateQuestions || []
                                    }
                                    idColumn={'question_id'}
                                    nameColumn={'name'}
                                />
                            </Grid>
                        </Fragment>
                    )}
                </Fragment>
            )}
        </Grid>
    );
}

export default observer(AssessmentTemplateQuestions);

